
<template >
  <div class="products-grid ma-4">
   <v-row no-gutters>
      <v-col cols="3" md="4">
        <v-list class="pa-0 ma-0">
          <v-subheader><b>Valitse sovituspaketti</b></v-subheader>
          <v-divider></v-divider>
          <v-list-item-group color="primary" v-model="selectedSamplePackage">
            
            <v-list-item
              v-for="(item) in Object.keys(getSamplePackages).reduce((result,key) => {result.push({text:samplePackages[key].name,value:samplePackages[key].id}); return result},[])"
              :key="item.value"
              :value="item.value"
              @click="v => setPackage(item.value)"
            >
              <v-list-item-content>
                <v-row no-gutters>
                  <v-col cols="12" >
                    <v-list-item-title v-text="item.text"></v-list-item-title>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col cols="9" md="8">
        
        <v-list class="pa-0 ma-0" v-if="selectedSamplePackage !== '' && samplePackages[selectedSamplePackage] !== undefined">
          <!-- {{samplePackages[selectedSamplePackage].productVariations}} -->
          <v-subheader><b>Sovituspakettiin sisältyvät tuotteet</b></v-subheader>
          <v-divider></v-divider>
          <v-list-item
            
            v-for="(item,index) in samplePackages[selectedSamplePackage].productVariations"
            :key="'list-product-variations-productvariation-'+index"
            :value="item.value"
          >
            <v-list-item-content >

              <v-row no-gutters v-if="productVariations[item.productVariationId] !== undefined">
                <v-col cols="12">
                  <v-list-item-title v-text="productCatalog[productVariations[item.productVariationId].productId].name.fi +'-'+ createVariationName(productVariations[item.productVariationId])"></v-list-item-title>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import firebase from 'firebase'
import shared from './../../shared'
var db = null
export default {
    created () {
      this.createVariationName = shared.createVariationName
    },
    data: () => ({
      table: null,
      errors: {
        clientPrintDetailsEmail:""
      },
      editedIndex: -1,
      samplePackages: {},
      productDefaultItem: {
        productId: '',
        productVariationId: '',
        customerProductName: '',
        productName: '',
        sku:'',
        quantity: '',
        color: '',
        size:'',
        numberOfSamples: 0,
        unitPrice: '',
        unitPrintPrice: '',
        printQuantity: '',
        printCostComments: '',
        packageType:'',
        numberOfPositionings: 0,
        pricePerPositioning: '',
        print: false,
        printColor: " ",
        printLocation: " ",
        printContent:" ",
        printComments: " ",
        latestToCustomer: '',
        whenToInvoice:'',
      },
      productErrorDefaultItem: {
          productId: '',
          productVariationId: '',
          customerProductName: '',
          productName: '',
          sku:'',
          color:'',
          size:'',
          packageType:'',
          quantity: '',
          numberOfSamples: '',
          unitPrice: '',
          unitPrintPrice: '',
          printQuantity: '',
          printCostComments:'',
          numberOfPositionings: '',
          pricePerPositioning:'',
          print: '',
          printColor: "",
          printLocation: "",
          printContent: "",
          printComments: "",
          latestToCustomer: '',
      },
      productsOtherInfoDefaultItem: {
          existingProductSelected:false
      },
      date: new Date().toISOString().substr(0, 10)
    }),
    
    mounted() {
      const table = this.$refs.table
      this.productsSearch = this.productsSearchTerm
      db = firebase.firestore();

      var t = this
      db.collection("samplePackages")
        .onSnapshot(function(querySnapshot) {
          t.samplePackages = {}
          querySnapshot.forEach(function(doc) {
              t.samplePackages[doc.id] = {...doc.data()}
          });
      })
    },
    computed: {
      getSamplePackages(){
        return this.samplePackages
      },
      isSamplesOrder(){
        if (this.typeOfOrder === 'sample') return true
        else return false
      },
      getPackageTypes(){
        var packageTypes = this.settings.packageTypes
        return Object.keys(this.settings.packageTypes).reduce(function(result, key) {
          result.push({...packageTypes[key]});
          return result;
        }, []);
      },
      ...mapFields({
        productCatalog:'product.products',
        productVariations:'productVariation.productVariations',
        settings:"settings",
        //isSamplesOrder:'newOrderDetails.isSamplesOrder',
        typeOfOrder:'newOrderDetails.typeOfOrder',
        samplesArray:"newOrderDetails.samplesArray",
        deliveryCharges:"newOrderDetails.deliveryCharges",
        positioningCharges:"newOrderDetails.positioningCharges",
        selectedSamplePackage:"newOrderDetails.selectedSamplePackage",
        clientPrintDetailsEmail:"newOrderDetails.clientPrintDetailsEmail",
        clientEmail:"newOrderDetails.clientEmail",
        orderedProductInvoiceStyles:"settings.orderedProductInvoiceStyles"
      }),
      ...mapMultiRowFields({
        products: "newOrderDetails.products2",
        productsErrors: "newOrderDetails.productsErrors",
        productsOtherInfo: "newOrderDetails.productsOtherInfo"
      })
    },
    methods: {
      setPackage(v){
        if (this.selectedSamplePackage === v) {
          console.log(v)
          this.selectedSamplePackage = ''
        }
        else{
          this.selectedSamplePackage = v
        }
      },
    }
  }
</script>

<style>
.v-list-item-group .v-list-item--active {
   color: #000 !important;
   background: #ccc !important;
}
   
</style>


// WEBPACK FOOTER //
// src/components/blocks/NewOrderSampleGrid.vue